$(document).ready(function () {
	$("#choiceRegion").change(function () {
		let val = $(this).val();
		let $items = $('.vacancy .vacancy-item');
		let cntActive = 0;

		if (val != 0) {
			$items.each(function (i, e) {
				let branches = String($(e).data('branches')).split(',');
				let active = branches.indexOf(val) !== -1;
				if (active) {
					$(e).show();
					cntActive++;
				} else {
					$(e).hide();
				}
			});
		} else {
			$items.show();
			cntActive = $items.length;
		}

		let $counterInfo = $('.info-text');
		let $counter = $counterInfo.find('.cnt');
		if (cntActive > 0) {
			$counterInfo.removeClass('empty');
			$counter.text(cntActive + ' ' + getWordForm(cntActive, ['вакансия', 'вакансии', 'вакансий']));
		} else {
			$counterInfo.addClass('empty');
			$counter.text('Не найдено вакансий');
		}
	});

	let $modalsVacancies = $("#modal-vacancy");
	$modalsVacancies.each(function () {
		$(this).on('show.bs.modal', function () {
			let $selectBranches = $(this).find('[name=branch_id]');
			$selectBranches.SumoSelect();
		});

		$(this).on('shown.bs.modal', function () {
			let branches = String($(this).find('[name=branches]').val()).split(',');
			let $selectBranches = $(this).find('[name=branch_id]');
			let $options = $selectBranches.find('option');
			$options.each(function (i, option) {
				let branchId = String($(option).val());
				let disabled = branches.indexOf(branchId) === -1;
				if (disabled) {
					$(option).attr('disabled', 'disabled');
				} else {
					$(option).removeAttr('disabled');
				}
			});

			$options.sort(function (a, b) {
				return ($(a).attr('disabled') ? 1 : 0) - ($(b).attr('disabled') ? 1 : 0);
			});
			$options.detach().appendTo($selectBranches);

			$selectBranches.find('option:not(:disabled)').first().prop('selected', true);
			$selectBranches.SumoSelect().sumo.reload();
		});
	});

	// Form Vacancy
	const $formVacancy = $('#form-vacancy');
	const modalVacancy = $('#modal-vacancy')
	modalVacancy.find('[data-toggle="send"]').click(function () {
		let $btn = $(this),
			data = new FormData(document.getElementById('form-vacancy')),
			error = true;

		for (const [key, val] of data) {
			if (key === 'files[]') {
				if (val.name) {
					error = false;
				}
			}
		}

		if (!error) {
			$btn.attr('disabled', true);
			$btn.text('Отправляем...');

			$formVacancy.trigger('submit');
		} else {
			let $modalConfirm = modalVacancy.find('.modal-confirm');
			$modalConfirm.addClass('show');

			modalVacancy.find('[data-toggle="cancel"]').click(function () {
				$modalConfirm.removeClass('show');
				return false;
			});
		}

		return false;
	});

	function sendFormVacancy($form) {
		$form.vegasFormSender({
			beforeSend: function (form, params) {
				AlertFormSender.Action.beforeSend(form, params);
			},
			success: function (data, form, params) {
				if (data.error) {
					AlertFormSender.Action.error(data.msg, form, params);
				} else {
					AlertFormSender.Action.success(data.msg, form, params);
				}

			},
			error: function (msg, form, params) {
				AlertFormSender.Action.error(msg, form, params);
			},
			validate: function (form, params, errors) {
				ValidateFormSender.init(errors, form, params);
			}
		});
	}
});
